import { render } from "./activityCreate.vue?vue&type=template&id=feb3941a&scoped=true"
import script from "./activityCreate.vue?vue&type=script&lang=js"
export * from "./activityCreate.vue?vue&type=script&lang=js"

import "./activityCreate.vue?vue&type=style&index=0&id=feb3941a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb3941a"]])

export default __exports__